import { FC } from "react";
import ICONS from "src/assets/icons";
import { motion } from "framer-motion";

const SERVICES = [
  {
    icon: ICONS.EnvCloud(),
    text: "Environnements cloud modernes",
  },
  {
    icon: ICONS.Code(),
    text: "Déploiement 1 clic : IA, code, bases de données",
  },
  {
    icon: ICONS.Iam(),
    text: "Gouvernance centralisée (IAM)",
  },
  {
    icon: ICONS.Pipeline(),
    text: "Pipelines DevOps intégrés",
  },
  {
    icon: ICONS.Tools(),
    text: "Outils d'observabilité 360°",
  },
  {
    icon: ICONS.ApiManagement(),
    text: "API Management",
  },
];

const InfiniteScroll: FC = () => {
  return (
    <div className="relative w-full overflow-hidden py-6 mt-[1rem]">
      <motion.div
        className="flex space-x-6 animate-loop mb-[7rem] mt-[1rem]"
        initial={{ x: 0 }}
        animate={{ x: "-100%" }}
        transition={{
          repeat: Infinity,
          duration: 10,
          ease: "linear",
        }}
      >
        {[...SERVICES, ...SERVICES].map((item, index) => (
          <div
            key={index}
            className="flex items-center bg-[#072642] text-white px-6 py-2 rounded-full space-x-3  mx-3"
          >
            {item.icon}
            <span className="whitespace-nowrap">{item.text}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

const ServicesSection: React.FC = () => {
  return (
    <div className="pl-4 bg-gradient-to-b from-[#05132D] to-[#061634]">
      <div className="flex items-center justify-center mt-[5rem] mx-auto text-center p-6">
        <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2]">
            Services Cloud de <br /> nouvelle{" "}
          <i className="app-title-italic text-[#20E87F] text-[48px]">
            génération{" "}
          </i>
        </h1>
      </div>
      <div className="ml-[3rem] mr-[3rem]">
        <InfiniteScroll />
      </div>
    </div>
  );
};

export default ServicesSection;
